import React from 'react'

import { OAImage1, OAImage2, OAImage3 } from '../../../../assets/images/landingV2/business'
import './styles.scss'
import './responsiveStyles.scss'

function OurApps() {
  return (
    <div id='ourapps' className='bl_oa'>
      <div className='bl_oa__title'>
        <h1>Наші застосунки</h1>
      </div>
      <div className='bl_oa__info'>
        <div className='bl_oa__info_item'>
          <div className='bl_oa__info_item_logo'>
            <img src={OAImage1} alt='Image 1' />
          </div>
          <div className='bl_oa__info_item_title'>
            <h5>01/</h5>
            <h6>Для барист</h6>
          </div>
          <div className='bl_oa__info_item_desc'>
            <ul>
              <li>отримання замовлень</li>
              <li>деталі кожного замовлення</li>
              <li>зміна статусу опрацювання</li>
              <li>статистика</li>
              <li>видача замовлень</li>
            </ul>
          </div>
        </div>
        <div className='bl_oa__info_item'>
          <div className='bl_oa__info_item_logo'>
            <img src={OAImage2} alt='Image 2' />
          </div>
          <div className='bl_oa__info_item_title'>
            <h5>02/</h5>
            <h6>Для бізнесу</h6>
          </div>
          <div className='bl_oa__info_item_desc'>
            <ul>
              <li>менеджмент персоналу</li>
              <li>статистика та звіти</li>
              <li>управління мережею</li>
              <li>додавання меню</li>
              <li>аналітика закладів</li>
            </ul>
          </div>
        </div>
        <div className='bl_oa__info_item'>
          <div className='bl_oa__info_item_logo'>
            <img src={OAImage3} alt='Image 3' />
          </div>
          <div className='bl_oa__info_item_title'>
            <h5>03/</h5>
            <h6>Для відвідувачів</h6>
          </div>
          <div className='bl_oa__info_item_desc'>
            <ul>
              <li>пошук закладів</li>
              <li>вибір напоїв та їжі</li>
              <li>передзамовлення</li>
              <li>програма лояльності</li>
              <li>справжній take-and-go</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OurApps
